import React, { PureComponent } from "react"
import PropTypes from "prop-types"
import { List } from "immutable"
import _isNil from "lodash/isNil"
import _noop from "lodash/noop"

// ui components
import Tag from "components/UI/elements/Tag"
import Button from "components/UI/elements/Button"

import { renderTooltip } from "helpers/disabledTooltip.helper"

import "./TagPicker.css"

class TagPicker extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      open: false,
      isHovering: null
    }

    this.wrapperRef = React.createRef()

    window.addEventListener("keyup", this.handleKeyUp, false)
    document.addEventListener("click", this.handleOutsideClick, false)
  }

  componentWillUnmount() {
    window.removeEventListener("keyup", this.handleKeyUp, false)
    document.removeEventListener("click", this.handleOutsideClick, false)
  }

  handleMouseHover = tagId => () => {
    this.setState({
      isHovering: tagId
    })
  }

  toggleOpen = () => {
    this.setState(prevState => ({
      open: !prevState.open,
      isHovering: null
    }))
  }

  handleKeyUp = evt => {
    const keys = {
      27: () => {
        if (this.state.open) {
          this.toggleOpen()
        }
      }
    }
    if (keys[evt.keyCode]) {
      keys[evt.keyCode]()
    }
  }

  handleOutsideClick = evt => {
    if (this.state.open && !_isNil(this.wrapperRef.current)) {
      if (!this.wrapperRef.current.contains(evt.target)) {
        this.toggleOpen()
      }
    }
  }

  onTagClick = tag => () => {
    this.props.onTagSelect(tag.id)
    this.toggleOpen()
  }

  render() {
    const {
      className,
      selectedTagIds,
      allTags,
      disabled,
      readyToEdit,
      currentlyEditing = "",
      tooltipId = ""
    } = this.props
    const { open, isHovering } = this.state

    const displayTags = allTags.filterNot(tag => selectedTagIds.includes(tag.id))

    return (
      <div
        className={`tag-picker ${className ? className : ""}`}
        ref={this.wrapperRef}
        data-tip={currentlyEditing.length > 0}
        data-for={currentlyEditing.length > 0 ? tooltipId : false}
      >
        <Button
          size="tag"
          color="white"
          type="button"
          className={`add-button ${!readyToEdit ? "cursor-wait" : ""}`}
          onClick={readyToEdit ? this.toggleOpen : _noop}
          disabled={disabled || currentlyEditing.length > 0}
        >
          <span className="plus">+</span>
          {((List.isList(selectedTagIds) && selectedTagIds.size === 0) ||
            (Array.isArray(selectedTagIds) && selectedTagIds.length === 0)) && (
            <span className="add-label"> add tag</span>
          )}
        </Button>
        {open && (
          <div className={`pick-area ${isHovering ? "active" : ""}`}>
            {displayTags.size > 0 &&
              displayTags
                .map(tag => (
                  <Tag
                    color={tag.color ? tag.color : "primary"}
                    size="small"
                    key={tag.id}
                    onClick={this.onTagClick(tag)}
                    onMouseEnter={this.handleMouseHover(tag.id)}
                    onMouseLeave={this.handleMouseHover(null)}
                    className={isHovering === tag.id ? "is-hovering" : ""}
                  >
                    {tag.name}
                  </Tag>
                ))
                .toArray()}
            {displayTags.size === 0 && <p className="warning-red">No options to select</p>}
          </div>
        )}
        {renderTooltip(tooltipId, currentlyEditing)}
      </div>
    )
  }
}

TagPicker.defaultProps = {
  readyToEdit: true
}

TagPicker.propTypes = {
  selectedTagIds: PropTypes.oneOfType([PropTypes.array, PropTypes.instanceOf(List)]).isRequired,
  allTags: PropTypes.instanceOf(List).isRequired,
  onTagSelect: PropTypes.func.isRequired,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  currentlyEditing: PropTypes.string,
  tooltipId: PropTypes.string,
  readyToEdit: PropTypes.bool
}

export default TagPicker
